import Maska from "maska";

export default function (app) {
  app.use(Maska);
}
